import { FieldValues, FormProvider } from 'react-hook-form'
import { Props } from './types'

export const ControlledForm = <T extends FieldValues>({ formMethods, children, ...rest }: Props<T>) => (
  <FormProvider {...formMethods}>
    <form {...rest}>{children}</form>
  </FormProvider>
)
